import {HTTP} from "@/http";

class LdapServerServiceClass {
  basePath = 'api/v2/ldap-servers';

  /**
   * Get all LDAP servers
   * @returns {Promise<Object>}
   */
  getAll() {
    return HTTP.get(this.basePath);
  }

  /**
   * Get a single LDAP server by ID
   * @param {string} id
   * @returns {Promise<Object>}
   */
  getById(id) {
    return HTTP.get(`${this.basePath}/${id}`);
  }

  /**
   * Create a new LDAP server
   * @param {Object} ldapServer
   * @returns {Promise<Object>}
   */
  create(ldapServer) {
    return HTTP.post(this.basePath, ldapServer);
  }

  /**
   * Update an existing LDAP server
   * @param {Object} ldapServer
   * @returns {Promise<Object>}
   */
  patch(ldapServer) {
    return HTTP.patch(`${this.basePath}/${ldapServer.id}`, ldapServer);
  }

  /**
   * Validate an LDAP server connection without persisting it.
   * @param {Object} server { id?, url, domain, syncUser, syncPassword }
   * @returns {Promise<Object>} resolves with LdapServerValidationResponseView
   *          ({ connected, message, error })
   */
  validate(server) {
    const body = {
      url: server.url,
      domain: server.domain,
      syncUser: server.syncUser,
    };
    if (server.syncPassword) {
      body.syncPassword = server.syncPassword;
    }
    if (server.id) {
      return HTTP.post(`${this.basePath}/${server.id}/validate`, body);
    }
    return HTTP.post(`${this.basePath}/validate`, body);
  }

  /**
   * Delete an LDAP server by ID
   * @param {string} id
   * @returns {Promise<Object>}
   */
  delete(id) {
    return HTTP.delete(`${this.basePath}/${id}`);
  }
}

/**
 * @type {LdapServerServiceClass}
 */
export const ldapServerService = new LdapServerServiceClass();
